var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.796,
    cy: 37.1553,
    r: 35.921,
    fill: "#505050",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_604_2353",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3877 74.2924V66.3623H37.2041V74.2924H36.3877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3878 8.7648V0H37.2041V8.7648H36.3878Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2109 9.19363L29.8877 0.529297L30.6947 0.406044L32.018 9.07038L31.2109 9.19363Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4057 10.3388L23.3081 2.13965L24.0718 1.85112L27.1694 10.0503L26.4057 10.3388Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1477 12.5483L17.8522 4.9082L18.5639 4.50811L22.8593 12.1482L22.1477 12.5483Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99744 38.3896H0.0673828V37.5732H7.99744V38.3896Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82164 33.0133L0.00014392 31.7056L0.134766 30.9004L7.95626 32.2081L7.82164 33.0133Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10292 27.5908L1.60413 25.0112L1.86969 24.2393L9.36848 26.8188L9.10292 27.5908Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1135 15.699L13.1045 9.43773L13.742 8.92773L18.751 15.189L18.1135 15.699Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4258 19.3642L8.16006 14.3607L8.66949 13.7228L14.9352 18.7263L14.4258 19.3642Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9442 23.232L4.88238 19.4341L5.26907 18.7151L12.3309 22.513L11.9442 23.232Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7892 65.9333L44.1125 74.5977L43.3055 74.7209L41.9822 66.0566L42.7892 65.9333Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5943 64.7891L50.6919 72.9883L49.9282 73.2768L46.8306 65.0776L47.5943 64.7891Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8525 62.5777L56.1479 70.2178L55.4363 70.6179L51.1409 62.9778L51.8525 62.5777Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0026 36.7383L73.9326 36.7383L73.9326 37.5547L66.0026 37.5547L66.0026 36.7383Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1784 42.1127L73.9999 43.4204L73.8652 44.2256L66.0437 42.9179L66.1784 42.1127Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8971 47.5372L72.3959 50.1167L72.1303 50.8887L64.6315 48.3091L64.8971 47.5372Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8865 59.4279L60.8955 65.6892L60.258 66.1992L55.249 59.9379L55.8865 59.4279Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.574 55.7618L65.8398 60.7652L65.3303 61.4032L59.0646 56.3997L59.574 55.7618Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0557 51.8949L69.1176 55.6929L68.7309 56.4119L61.669 52.6139L62.0557 51.8949Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1222 32.1188L73.8018 30.8994L73.9153 31.7079L65.2358 32.9272L65.1222 32.1188Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87488 43.0101L0.195312 44.2295L0.0817376 43.421L8.76131 42.2017L8.87488 43.0101Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4873 27.1265L71.6274 23.877L71.9301 24.6352L63.7899 27.8847L63.4873 27.1265Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5108 48.0014L2.37061 51.251L2.06793 50.4928L10.2081 47.2432L10.5108 48.0014Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0608 8.90033L42.8042 1.16428L43.6006 1.34375L41.8572 9.07981L41.0608 8.90033Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.937 66.2296L31.1936 73.9656L30.3972 73.7861L32.1406 66.0501L32.937 66.2296Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3432 9.90933L49.3383 2.56665L50.0942 2.875L47.0991 10.2177L46.3432 9.90933Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6532 65.2186L24.658 72.5613L23.9021 72.2529L26.8973 64.9103L27.6532 65.2186Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6407 11.9601L54.8056 5.21185L55.5004 5.64062L51.3354 12.3889L50.6407 11.9601Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3564 63.1678L19.1914 69.9161L18.4967 69.4873L22.6617 62.739L23.3564 63.1678Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.635 22.5471L68.5752 18.5311L68.984 19.2377L62.0439 23.2537L61.635 22.5471Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3628 52.5809L5.42265 56.5968L5.01377 55.8902L11.9539 51.8742L12.3628 52.5809Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2481 18.4678L64.5066 13.4554L65.017 14.0926L58.7584 19.105L58.2481 18.4678Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 56.6611L9.49144 61.6735L8.98109 61.0363L15.2396 56.0239L15.75 56.6611Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9195 15.3871L60.177 9.333L60.7934 9.86829L55.5359 15.9224L54.9195 15.3871Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0775 59.7428L13.82 65.7969L13.2036 65.2616L18.4611 59.2075L19.0775 59.7428Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_604_2353)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.6129,
    cy: 37.1563,
    r: 35.921,
    fill: "#D9D9D9"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8653 42.792L31.4739 29.2919C31.4247 29.2213 31.5041 29.1325 31.5798 29.1735L45.6641 36.8025L61.6394 43.311C61.7102 43.3398 61.7061 43.4414 61.6332 43.4644L50.5078 46.9777C50.4783 46.987 50.4566 47.0122 50.4517 47.0428L48.701 58.1306C48.6886 58.209 48.5829 58.2254 48.5474 58.1543L40.8713 42.8021C40.8695 42.7986 40.8675 42.7952 40.8653 42.792Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6028 28.7606L25.9505 29.5111L19.9463 24.293L20.861 23.2405C23.0169 23.5999 27.6286 24.3219 28.5681 24.5478L28.5755 24.5392C27.7553 23.9323 26.8138 23.099 25.839 22.2518L23.4925 20.2125L24.1448 19.462L30.149 24.6801L29.2868 25.6722C27.2944 25.3337 22.3909 24.4944 21.3956 24.2806L21.3806 24.2978C22.0996 24.847 23.1176 25.7317 24.2046 26.6763L26.6028 28.7606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/Compass.c368785f9f7a44ec116688d16ad4a3ca.svg";
export { ForwardRef as ReactComponent };